const getBlocks = (blocks) => blocks.filter(({ block_name }) => block_name === 'symptom_intensity');

export default getBlocks;
